import { makeSx } from '../../../../theme/_utils'
import { defaultPalette } from '../../../../theme/idsTheme'
import { hexToRgba } from '../../../../utils/commonUtils'

export default makeSx({
    PatientFormModificationsHistoryRowTag: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
    },
    PatientFormModificationsHistoryRowContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '.5rem',
    },
    PatientFormModificationsHistoryRowContentMain: {},
    PatientFormModificationsHistoryRowContentDetail: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1rem',
    },
    PatientFormModificationsHistoryRowContentDetailItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '.1rem',
        background: hexToRgba(defaultPalette.lightGrey.medium, 0.2),
        padding: '.5rem .7rem',
        borderRadius: '.9rem',
        minWidth: '8rem',
        maxWidth: '25%',
    },
})
